import { AppEnvironment } from '../../api/interfaces';
import { environment } from './../../../environments/environment';

export const activeEnvironment: AppEnvironment = environment.environmentName;
export const isLocalHost = window.location.hostname.includes('localhost');
